module.exports = __webpack_public_path__ + "img/featuredartist (8).f66fbcba.jpg";